import React from "react";
import { BsCheckCircle } from "react-icons/bs";

const StepIndicator = ({ steps, currentStep }) => {
	return (
		<div className="flex items-center justify-center space-x-8 mb-6">
			{steps.map((step, index) => (
				<div key={index} className="flex items-center">
					<div
						className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-200 ${
							index < currentStep
								? "bg-akgreen text-white"
								: index === currentStep
									? "bg-akgreener text-white"
									: "bg-gray-200 text-gray-500"
						}`}
					>
						{index < currentStep ? (
							<BsCheckCircle className="text-sm" />
						) : (
							step.icon || index + 1
						)}
					</div>
					{index < steps.length - 1 && (
						<div
							className={`w-16 h-0.5 mx-4 transition-all duration-200 ${
								index < currentStep ? "bg-akgreen" : "bg-gray-200"
							}`}
						/>
					)}
				</div>
			))}
		</div>
	);
};

export default StepIndicator;
